import { Theme } from '@mui/material'
import { SxProps } from '@mui/system'

const getOverflowSectionSX: SxProps<Theme> = {
    maxHeight: {
        xs: `calc(100vh - 355px)`,
        sm: `calc(100vh - 355px)`,
        md: `calc(100vh - 350px)`,
    },
    // height: '100%',
    overflow: 'auto',
}

export default getOverflowSectionSX
